import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { renderRoutes } from 'react-router-config';
import PaymentProvider from '../PaymentProvider';
import { getRoutesWithStore } from '../../routes';

const AppEntry = ({ store, history, paymentProviderApiKey }) => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <PaymentProvider apiKey={paymentProviderApiKey}>
        {renderRoutes(getRoutesWithStore(store))}
      </PaymentProvider>
    </ConnectedRouter>
  </Provider>
);

AppEntry.propTypes = {
  store: PropTypes.object,
  history: PropTypes.object,
  paymentProviderApiKey: PropTypes.string,
};

export { AppEntry };
